import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import QuizPage from './QuizPage';
import QuizEndPage from './QuizEndPage';

const deps = {
  quizPageIndex: state.challenge.tagModal.quizPageIndex,
};

function Quiz({
  quizPageIndex,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (quizPageIndex === 0) return <QuizEndPage />;

  return <QuizPage />;
}

export default connect(deps, Quiz);
